module.exports = __webpack_public_path__ + "static/media/gry-edukacyjne-dla-10-latka-11-latka.d6e76004.png";